/* Snactivate mix-and-match (2026-10-19). PDP pack chooser + cart "Mix your pack" strip.
   Uses /cart/add.js (items[]) and /cart/change.js with Dawn section rendering, so the cart drawer,
   cart bubble and /cart page refresh the same way Dawn's own quantity buttons do. */
(function () {
  if (window.snxMix) return;
  window.snxMix = true;

  function cfg(body) {
    return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) };
  }
  function mainCart() { var c = document.querySelector('cart-items'); return c && document.getElementById('main-cart-items') ? c : null; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionsWanted() {
    var m = mainCart();
    if (m && m.getSectionsToRender) return m.getSectionsToRender().map(function (s) { return s.section; });
    return ['cart-drawer', 'cart-icon-bubble'];
  }
  function inner(html, sel) {
    var d = new DOMParser().parseFromString(html, 'text/html');
    var n = d.querySelector(sel);
    return n ? n.innerHTML : null;
  }
  function paint(state, count, openDrawer) {
    var m = mainCart();
    if (m && m.getSectionsToRender) {
      m.getSectionsToRender().forEach(function (s) {
        var host = document.getElementById(s.id);
        if (!host || !state.sections || !state.sections[s.section]) return;
        var el = host.querySelector(s.selector) || host;
        var h = inner(state.sections[s.section], s.selector);
        if (h !== null) el.innerHTML = h;
      });
      m.classList.toggle('is-empty', count === 0);
      var f = document.getElementById('main-cart-footer');
      if (f) f.classList.toggle('is-empty', count === 0);
      return;
    }
    var d = drawer();
    if (d && state.sections && state.sections['cart-drawer']) {
      if (openDrawer && d.renderContents) { d.renderContents(state); }
      else {
        var cd = document.getElementById('CartDrawer');
        var h2 = inner(state.sections['cart-drawer'], '#CartDrawer');
        if (cd && h2 !== null) {
          cd.innerHTML = h2;
          var ov = d.querySelector('#CartDrawer-Overlay');
          if (ov) ov.addEventListener('click', d.close.bind(d));
        }
        var bub = document.getElementById('cart-icon-bubble');
        var hb = state.sections['cart-icon-bubble'] && inner(state.sections['cart-icon-bubble'], '.shopify-section');
        if (bub && hb !== null && hb !== undefined) bub.innerHTML = hb;
      }
      d.classList.toggle('is-empty', count === 0);
      var di = d.querySelector('.drawer__inner');
      if (di) di.classList.toggle('is-empty', count === 0);
      return;
    }
    window.location.href = (window.routes && window.routes.cart_url) || '/cart';
  }
  function notify(state) {
    try { if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'snx-mix', cartData: state }); } catch (e) {}
  }
  function getCart() { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function errText(j) { return (j && (j.description || j.message)) || 'Something went wrong. Please try again.'; }

  /* ---------- PDP pack chooser ---------- */
  function packState(root) {
    var r = root.querySelector('input[type=radio]:checked');
    return r ? parseInt(r.dataset.boxes || '1', 10) : 1;
  }
  function chooserTotal(root) {
    var t = 0;
    root.querySelectorAll('.snx-pack__row').forEach(function (row) { t += parseInt(row.querySelector('[data-snx-qty]').textContent, 10) || 0; });
    return t;
  }
  function addBtn(root) {
    var form = document.getElementById(root.dataset.formId);
    return form ? form.querySelector('[name="add"]') : null;
  }
  function syncSticky(root, locked) {
    var bar = document.querySelector('.snx-sticky[data-form-id="' + root.dataset.formId + '"] .snx-sticky__btn');
    if (!bar) return;
    var lbl = bar.querySelector('[data-snx-label]');
    /* run after the sticky bar's own MutationObserver, which would otherwise label a locked button "Back soon" */
    setTimeout(function () {
      var mb = addBtn(root);
      locked = !!(mb && mb.dataset.snxLock); /* re-read: an earlier queued call must not win over the latest state */
      if (locked) {
        bar.disabled = true; bar.dataset.snxLock = '1';
        if (lbl) lbl.textContent = root.querySelector('[data-snx-count]').textContent.split(' · ')[0];
      } else if (bar.dataset.snxLock) {
        bar.disabled = false; delete bar.dataset.snxLock; /* the sticky bar's observer restores "Add to cart" */
      }
    }, 0);
  }
  function buyNow(root, show) {
    /* "Buy it now" buys only the form's single variant, so hide it while a mix-and-match pack is selected */
    var form = document.getElementById(root.dataset.formId);
    var pb = form && form.querySelector('.shopify-payment-button');
    if (pb) pb.style.display = show ? '' : 'none';
  }
  function refreshChooser(root) {
    var need = packState(root), ch = root.querySelector('[data-snx-chooser]');
    var btn = addBtn(root);
    buyNow(root, need === 1);
    if (need === 1) {
      ch.hidden = true;
      if (btn && btn.dataset.snxLock) { btn.disabled = false; btn.removeAttribute('aria-disabled'); delete btn.dataset.snxLock; }
      syncSticky(root, false);
      return;
    }
    ch.hidden = false;
    var tot = chooserTotal(root);
    root.querySelectorAll('.snx-pack__row').forEach(function (row) {
      var q = parseInt(row.querySelector('[data-snx-qty]').textContent, 10) || 0, max = parseInt(row.dataset.max, 10) || 0;
      row.querySelector('[data-snx-step="-1"]').disabled = q <= 0;
      row.querySelector('[data-snx-step="1"]').disabled = tot >= need || q >= max;
    });
    var left = need - tot, c = root.querySelector('[data-snx-count]');
    c.textContent = left > 0 ? ('Pick ' + left + ' more ' + (left === 1 ? 'box' : 'boxes') + ' · ' + tot + ' of ' + need + ' picked')
      : (tot + ' of ' + need + ' boxes picked · ' + (need * 6) + ' bars');
    if (btn) {
      if (left !== 0) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.dataset.snxLock = '1'; }
      else if (btn.dataset.snxLock) { btn.disabled = false; btn.removeAttribute('aria-disabled'); delete btn.dataset.snxLock; }
    }
    syncSticky(root, left !== 0);
  }
  function prefill(root) {
    var need = packState(root), cur = root.dataset.current, placed = 0;
    var rows = [].slice.call(root.querySelectorAll('.snx-pack__row'));
    rows.forEach(function (r) { r.querySelector('[data-snx-qty]').textContent = '0'; });
    var mine = rows.filter(function (r) { return r.dataset.variant === cur; })[0];
    var order = (mine ? [mine] : []).concat(rows.filter(function (r) { return r !== mine; }));
    order.forEach(function (r) {
      var max = parseInt(r.dataset.max, 10) || 0, give = Math.min(max, need - placed);
      if (give > 0) { r.querySelector('[data-snx-qty]').textContent = String(give); placed += give; }
    });
  }

  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i.matches || !i.matches('.snx-pack input[type=radio]')) return;
    var root = i.closest('.snx-pack');
    document.dispatchEvent(new CustomEvent('snx:option', { detail: { price: i.dataset.price || '' } })); /* sticky bar price */
    if (parseInt(i.dataset.boxes, 10) > 1) prefill(root);
    root.querySelector('[data-snx-err]').hidden = true;
    refreshChooser(root);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-snx-step]');
    if (b) {
      var root = b.closest('.snx-pack'), row = b.closest('.snx-pack__row'), q = row.querySelector('[data-snx-qty]');
      var v = Math.max(0, (parseInt(q.textContent, 10) || 0) + parseInt(b.dataset.snxStep, 10));
      q.textContent = String(v);
      refreshChooser(root);
      return;
    }
    var m = e.target.closest && e.target.closest('[data-snx-mix]');
    if (m) { mixClick(m); }
  });

  /* Intercept the PDP product form only when a 2/3-box pack is selected (capture phase, before Dawn's product-form). */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var fid = form && form.getAttribute && form.getAttribute('id'); /* not form.id: the form has an input named "id" */
    if (!fid) return;
    var root = document.querySelector('.snx-pack[data-form-id="' + fid + '"]');
    if (!root) return;
    var need = packState(root);
    if (need === 1) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (chooserTotal(root) !== need) { refreshChooser(root); return; }
    var items = [];
    root.querySelectorAll('.snx-pack__row').forEach(function (row) {
      var q = parseInt(row.querySelector('[data-snx-qty]').textContent, 10) || 0;
      if (q > 0) items.push({ id: parseInt(row.dataset.variant, 10), quantity: q });
    });
    var btn = addBtn(root), err = root.querySelector('[data-snx-err]');
    if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); var sp = btn.querySelector('.loading__spinner'); if (sp) sp.classList.remove('hidden'); }
    err.hidden = true;
    fetch('/cart/add.js', cfg({ items: items, sections: sectionsWanted(), sections_url: window.location.pathname }))
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { err.textContent = errText(res.j); err.hidden = false; return; }
        return getCart().then(function (cart) { paint(res.j, cart.item_count, true); notify(cart); });
      })
      .catch(function () { err.textContent = errText(null); err.hidden = false; })
      .finally(function () {
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); var sp2 = btn.querySelector('.loading__spinner'); if (sp2) sp2.classList.add('hidden'); }
      });
  }, true);

  /* ---------- Cart strip ---------- */
  function mixClick(b) {
    var strip = b.closest('.snx-mix');
    var row = b.closest('.snx-mix__row');
    if (!strip || !row || b.disabled) return;
    var delta = parseInt(b.dataset.snxMix, 10), id = parseInt(row.dataset.variant, 10), q = parseInt(row.dataset.qty, 10) || 0;
    var err = strip.querySelector('.snx-mix__err');
    strip.querySelectorAll('button').forEach(function (x) { x.disabled = true; });
    strip.setAttribute('aria-busy', 'true');
    var req = delta > 0
      ? fetch('/cart/add.js', cfg({ items: [{ id: id, quantity: 1 }], sections: sectionsWanted(), sections_url: window.location.pathname }))
      : fetch('/cart/change.js', cfg({ id: String(id), quantity: Math.max(0, q - 1), sections: sectionsWanted(), sections_url: window.location.pathname }));
    req.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || res.j.status) { err.textContent = errText(res.j); err.hidden = false; strip.querySelectorAll('button').forEach(function (x) { x.disabled = false; }); return; }
        return getCart().then(function (cart) { paint(res.j, cart.item_count, false); notify(cart); });
      })
      .catch(function () { err.textContent = errText(null); err.hidden = false; strip.querySelectorAll('button').forEach(function (x) { x.disabled = false; }); });
  }
})();
